<template>
  <v-overlay absolute :value="true">
    <v-progress-circular
        indeterminate
        size="64"
    />
  </v-overlay>
</template>
<script>
export default {
  data: () => ({}),
  components: {},
  computed: {},
  mounted() {
    this.nextUnit()
  },
  methods: {
    nextUnit() {
      // this.$router.push({name: '솔루션', params: {'unitUseNo': this.$route.query.unitUseNo, 'popupYn':true, 'freeYn': 'N', 'cmpltYn':true, 'regDt':this.$route.query.regDt}})
      this.$router.replace({name: '솔루션', query: {'unitUseNo': this.$route.query.unitUseNo, 'popupYn': true, 'freeYn': this.$route.query.freeYn || 'N', 'cmpltYn': true, 'regDt': this.$route.query.regDt}})
    }
  }

}
</script>
